import { render, staticRenderFns } from "./RoundedTag.vue?vue&type=template&id=60cbe398"
import script from "./RoundedTag.vue?vue&type=script&lang=js"
export * from "./RoundedTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports